const structuredLog = require('structured-log');

const LogPlugin = {
    install(Vue, options) {
        let logConfig = structuredLog.configure();
        logConfig = logConfig.minLevel(options.minLevel);
        logConfig = logConfig.writeTo(new structuredLog.ConsoleSink({ console: console }));
        Vue.prototype.$log = logConfig.create();
    }
};

export default LogPlugin;